import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Home from '../Home'
import PlacesList from '../components/Places/List'
import MeWorkshops from '../components/Me/Workshops'
import MeCancelWorkshop from '../components/Me/CancelWorkshop'

const routes = [
    { path: '/', component: Home, name: 'home' },
    { path: '/places', component: PlacesList, name: 'places.choice' },
    { path: '/me/workshops', component: MeWorkshops, name: 'me.workshops', alias: '/mine' },
    { path: '/me/workshops/:workshopUuid/cancel', component: MeCancelWorkshop, name: 'me.workshops.cancel' },
]

const router = new VueRouter({
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
